module.exports = __webpack_public_path__ + "static/media/stream_bodyrok_video_classes.9783d39d.svg";